import find from 'lodash/find';
import buildContact from '../../../../Contact/buildContact';

const defaultBillingConfig = [ 'NAME', 'ADDRESS', 'EMAIL' ];

export const getCollectStatus = (collectBillingContactConfigs, type) => {
  const findObject = find(collectBillingContactConfigs, [ 'paymentMethodType', type ]);
  // not config or collectBillingContact is true will collect billing info
  return !findObject || findObject.collectBillingContact;
};

export const getBillingContactComponent = (billingContactConfig) => {
  const defautBillingContactConfig = billingContactConfig || defaultBillingConfig;

  return buildContact(defautBillingContactConfig);
};
